export default __webpack_public_path__ + "static/media/passport-loading-image.20b32be9.svg";